exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".custom-badge{font-size:.8rem;padding:5px}.marquee-container{width:100%;overflow:hidden}.marquee{animation:marquee 15s linear infinite}@keyframes marquee{0%{transform:translateX(100%)}to{transform:translateX(-100%)}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c8df1d38","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/component/allModuleForm/viewBillingDetails.vue
// module id = 1799
// module chunks = 0